exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.albert-border-bottom {\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports
